import { getCookie } from 'utils/cookie.helper';
import { TApi } from 'utils/api';
import { TProjectConfigurationParameter } from 'entries/common/widgets/project-configuration/context';
import { ENDPOINTS } from '../../../const';
import { TCreateConfigurationBody } from '../../../types';
import { setConfigurationIdCookie } from '../../../helpers/set-configuration-id-cookie';
import { dispatchProjectUpdatedCustomEvent } from '../../../helpers/dispatch-project-updated-custom-event';

type TFacet = {
  id: string;
  values: string[];
};

export const submitForm = async ({
  api,
  projectConfigurationCookieName,
  roomIdsWithSameInputParams,
  createConfigurationBody,
  projectUpdatedCustomEventName,
  projectUpdatedCustomEventPayload,
}: {
  api: TApi;
  projectConfigurationCookieName: string;
  roomIdsWithSameInputParams: string[];
  createConfigurationBody: TCreateConfigurationBody;
  projectUpdatedCustomEventName: string;
  projectUpdatedCustomEventPayload: {
    projectConfigurationParameters: Array<TProjectConfigurationParameter>;
    facets: TFacet[];
  };
}) => {
  if (roomIdsWithSameInputParams.length > 1) {
    const projectConfigurationId = getCookie(projectConfigurationCookieName);
    /* Если комнат с такими параметрами найдено несколько,
       то мы по возможности не меняем значение куки проекта - считаем, что он с ним уже работал.
       Исключение - если проект в куке не совпадает с теми, которые найдены по параметрам
     */
    if (!projectConfigurationId || !roomIdsWithSameInputParams.includes(projectConfigurationId)) {
      setConfigurationIdCookie({
        projectConfigurationId: roomIdsWithSameInputParams[0],
        projectConfigurationCookieName,
      });
    }
  } else if (roomIdsWithSameInputParams.length === 1) {
    setConfigurationIdCookie({
      projectConfigurationId: roomIdsWithSameInputParams[0],
      projectConfigurationCookieName,
    });
  } else {
    const res = await api.post(ENDPOINTS.CREATE_CONFIGURATION, createConfigurationBody);
    setConfigurationIdCookie({
      projectConfigurationId: res.projectConfigurationId,
      projectConfigurationCookieName,
    });
  }
  dispatchProjectUpdatedCustomEvent({ projectUpdatedCustomEventName, projectUpdatedCustomEventPayload });
};
